
import { defineComponent, PropType } from 'vue'
import { CheckStatus, ScaCheckStatus } from '~/types/types'
import { checkStatusIcon, checkStatusIconColor, checkStatusTagLabel } from '~/utils/ui'

/**
 * Nav header component for run details page. Lists:
 *
 * - Information about run like branch name, PR, commits, time taken, time created and other runs on the branch.
 */
export default defineComponent({
  name: 'RunHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    status: {
      type: String as PropType<CheckStatus | ScaCheckStatus>,
      required: true
    }
  },
  computed: {
    pillIcon(): string {
      return checkStatusIcon(this.status)
    },
    pillIconColor(): string {
      return checkStatusIconColor(this.status)
    },
    pillLabel(): string {
      return checkStatusTagLabel(this.status)
    }
  }
})
